var jobListings = {
  load:function(){
    this.convertDates();
    this.events();
  },
  events:function(){
    var self = this;



    var descriptionExpandLinks = document.getElementsByClassName("jobListingDescriptionExpand");
    for(let d of descriptionExpandLinks){
      d.addEventListener("click",function(e){
        e.preventDefault();
        var description = e.currentTarget.parentNode.getElementsByClassName("description");
        if(description && description[0]){
          description[0].classList.add("show");
        }
        e.currentTarget.remove();

      });

    }
  },
  convertDates:function(){
    var dates = document.getElementsByClassName("jobListingDate");
    for(let d of dates){
      d.innerHTML = timeago.format(new Date(parseInt(d.innerHTML)));
    }
  }
};
